exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* purgecss start ignore */\n.vc-base-stripe-control__input[data-v-1d81ca8c] {\n  padding-top: 22px;\n}\n\n/* purgecss end ignore */\n", ""]);
